import React, { PureComponent, useState } from 'react';
import {
    Row, Modal, ModalHeader, ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { clearStoreData } from '../redux/actions';
import { Link } from 'react-router-dom';

class SessionExpiryModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    //to clear the ddata from store
    sessionExpired = () => {
        let { sessionExpired } = this.props;
        sessionExpired()
    }

    render() {
        const { isOpen, withoutBrach } = this.props;
        return (
            <div>
                <Modal isOpen={isOpen} centered={true} size='lg'>
                    <ModalHeader className="bold-text" style={{ backgroundColor: '#323657', color: 'white', textAlign: 'center' }}  >
                        You're being timed out due to inactivity
                    </ModalHeader>
                    <ModalBody className='content__modal'>
                        <h5 className="py-3">We’re Sorry </h5>
                        {withoutBrach ? <h5 className="py-3">{'Your session has expired please try again'}</h5> : <h5 className="py-3">{'Your session has expired please login again'}</h5>}
                        {withoutBrach ? <Row className="justify-content-center">

                            <button className="btn btn-primary btn-lg" onClick={this.sessionExpired}
                                style={{ backgroundColor: '#323657', border: 'none' }}>Try Again</button>

                        </Row> :
                            <Row className="justify-content-center">
                                <button className="btn btn-primary btn-lg" onClick={this.sessionExpired} style={{ backgroundColor: '#323657', border: 'none' }}>Login again</button>
                            </Row>
                        }
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}
export default connect(
    null,
    (dispatch => ({
        sessionExpired: bindActionCreators(clearStoreData, dispatch)
    }))
)(SessionExpiryModal);